module.exports = __webpack_public_path__ + "static/media/flower-shadow.ab5c7ae3.png";